import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import InputRow from 'components/IncorporationOfTerms/Register/FormAtoms/InputRow';
import InputAddExp from 'components/IncorporationOfTerms/Register/FormAtoms/InputAddExp';

export const EmailForm = ({ disabled, isAdmin }) => {
  const { getValues, setValue, trigger } = useFormContext();

  useEffect(() => {
    if (!disabled && getValues('xtnlEmailAddr') && getValues('xtnlEmailAddr') !== '') {
      setValue('email', getValues('xtnlEmailAddr'));
      trigger('email');
    }
  }, [getValues('xtnlEmailAddr')]);

  return (
    <>
      <InputRow
        header="EM_T_EMAIL"
        name="email"
        disabled={disabled}
        placeholderLabel="MB_T_MAIL_HOLDER"
        isRequired={isAdmin}
        autoComplete="off"
      >
        <InputAddExp textLabel="MB_T_CATION_EMAIL" />
      </InputRow>
    </>
  );
};
EmailForm.propTypes = { disabled: PropTypes.bool, isAdmin: PropTypes.bool };
EmailForm.defaultProps = { disabled: false, isAdmin: false };
export default EmailForm;
